import productSearch from "./components/layout/product-search-and-cart";
import cookies from "./components/layout/cookies";
import announcementBar from './components/announcement-bar/announcementBar';

productSearch();
cookies();
announcementBar();


// import HideAndSeek from "./components/layout/HideAndSeek";

// Hide&Seek Easter
// new HideAndSeek();

//window.cookie = cookie;
